(function(){
var listeners = [];
var cartCache = null;

function setCart(data) {
  try { cartCache = typeof data === 'string' ? JSON.parse(data) : data; } catch(e) { cartCache = { items: [], item_count: 0, total_price: 0 }; }
  if (!cartCache.items) cartCache.items = [];
  cartCache.item_count = cartCache.item_count || 0;
  cartCache.total_price = cartCache.total_price || 0;
}

function triggerUpdate() {
  for (var i = 0; i < listeners.length; i++) {
    try {
      listeners[i]({
        cart: cartCache || { items: [], item_count: 0, total_price: 0 },
        count: getCount(),
        subtotal: getSubtotal()
      });
    } catch(e) {}
  }
}

function fetchCart(callback) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', '/cart.js', true);
  xhr.onload = function() {
    if (xhr.status === 200) {
      setCart(xhr.responseText);
      if (callback) callback(cartCache);
      triggerUpdate();
    }
  };
  xhr.send();
}

function addItem(item, callback) {
  var data = 'id=' + encodeURIComponent(item.variantId) + '&quantity=' + (item.qty || 1);
  var xhr = new XMLHttpRequest();
  xhr.open('POST', '/cart/add.js', true);
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.onload = function() {
    if (xhr.status === 200) {
      // /cart/add.js returns ONLY the added line item, not the whole cart.
      // Refetch /cart.js so the drawer/badge get real items, count & total.
      fetchCart(function(cart) { if (callback) callback(cart); });
    } else {
      try { var err = JSON.parse(xhr.responseText); alert(err.description || 'Error adding item'); } catch(e) {}
    }
  };
  xhr.send(data);
}

function updateQty(variantId, qty, callback) {
  var data = 'id=' + encodeURIComponent(variantId) + '&quantity=' + Math.max(0, parseInt(qty) || 0);
  var xhr = new XMLHttpRequest();
  xhr.open('POST', '/cart/change.js', true);
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.onload = function() {
    if (xhr.status === 200) {
      setCart(xhr.responseText);
      if (callback) callback(cartCache);
      triggerUpdate();
    }
  };
  xhr.send(data);
}

function removeItem(variantId, callback) {
  updateQty(variantId, 0, callback);
}

function clearCart(callback) {
  var xhr = new XMLHttpRequest();
  xhr.open('POST', '/cart/clear.js', true);
  xhr.onload = function() {
    if (xhr.status === 200) {
      setCart(xhr.responseText);
      if (callback) callback(cartCache);
      triggerUpdate();
    }
  };
  xhr.send();
}

function getCount() {
  return cartCache ? cartCache.item_count : 0;
}

function getSubtotal() {
  return cartCache ? cartCache.total_price : 0;
}

function getItems() {
  return cartCache ? cartCache.items : [];
}

function onUpdate(fn) { listeners.push(fn); }

fetchCart();

// ====== ADD-TO-CART POPUP ======
var atcMilestones = [
  { amount: 0, label: '$0', desc: 'Just started', offer: '' },
  { amount: 7500, label: '$75', desc: 'Free Shipping', offer: 'You unlocked Free Shipping!' },
  { amount: 15000, label: '$150', desc: 'Free Gift', offer: 'Add a Free Gift to your order!' },
  { amount: 25000, label: '$250', desc: '15% Off', offer: 'Use code ARC15 for 15% off!' }
];

function showAtcPopup(itemData) {
  var popup = document.getElementById('atcPopup');
  if (!popup) return;
  var img = document.getElementById('atcPopupImg');
  var title = document.getElementById('atcPopupProduct');
  var count = document.getElementById('atcPopupCount');
  var labels = document.getElementById('atcBarLabels');
  var fill = document.getElementById('atcBarFill');
  var dots = document.getElementById('atcBarDots');
  var msg = document.getElementById('atcBarMsg');
  if (img && itemData.image) img.src = itemData.image;
  if (title && itemData.title) title.textContent = itemData.title;
  if (count) count.textContent = '(' + (cartCache ? cartCache.item_count : 0) + ')';
  var subtotal = cartCache ? cartCache.total_price : 0;
  var maxAmount = atcMilestones[atcMilestones.length - 1].amount;
  var pct = maxAmount > 0 ? Math.min(100, (subtotal / maxAmount) * 100) : 0;
  if (fill) fill.style.width = pct + '%';
  if (labels) {
    var h = '';
    for (var i = 0; i < atcMilestones.length; i++) {
      var m = atcMilestones[i];
      var reached = subtotal >= m.amount;
      var isNext = !reached && (i === 0 || subtotal >= atcMilestones[i - 1].amount);
      var cls = reached ? 'reached' : (isNext ? 'active-offer' : '');
      h += '<span class="' + cls + '">' + m.label + '<span class="milestone-desc">' + m.desc + '</span></span>';
    }
    labels.innerHTML = h;
  }
  if (dots) {
    var d = '';
    for (var i = 0; i < atcMilestones.length; i++) {
      var m = atcMilestones[i];
      var left = (m.amount / maxAmount) * 100;
      var reached = subtotal >= m.amount;
      var isCurrent = i > 0 && !reached && subtotal >= atcMilestones[i - 1].amount;
      if (i === 0) isCurrent = false;
      if (i === atcMilestones.length - 1 && subtotal >= m.amount) { reached = true; isCurrent = false; }
      var cls = reached ? 'reached' : (isCurrent ? 'active' : '');
      d += '<span class="' + cls + '" style="left:' + left + '%"></span>';
    }
    dots.innerHTML = d;
  }
  if (msg) {
    var nextMilestone = null;
    for (var i = 0; i < atcMilestones.length; i++) {
      if (subtotal < atcMilestones[i].amount) { nextMilestone = atcMilestones[i]; break; }
    }
    if (nextMilestone) {
      var remaining = (nextMilestone.amount - subtotal) / 100;
      msg.innerHTML = 'Add <strong>$' + remaining.toFixed(2) + '</strong> more for <strong>' + nextMilestone.desc + '</strong>';
    } else {
      msg.innerHTML = 'You\'ve unlocked all offers!';
    }
  }
  popup.classList.remove('visible');
  void popup.offsetWidth;
  popup.classList.add('visible');
  if (popup._autoClose) clearTimeout(popup._autoClose);
  popup._autoClose = setTimeout(function() {
    popup.classList.remove('visible');
  }, 5000);
}

// Close popup handlers
document.addEventListener('click', function(e) {
  var popup = document.getElementById('atcPopup');
  if (!popup) return;
  if (e.target.closest('#atcPopupClose') || e.target.closest('#atcContinue')) {
    popup.classList.remove('visible');
    if (popup._autoClose) clearTimeout(popup._autoClose);
  }
});

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    var popup = document.getElementById('atcPopup');
    if (popup && popup.classList.contains('visible')) {
      popup.classList.remove('visible');
      if (popup._autoClose) clearTimeout(popup._autoClose);
    }
  }
});

window.ArcCart = {
  get: getItems,
  fetch: fetchCart,
  add: addItem,
  remove: removeItem,
  updateQty: updateQty,
  clear: clearCart,
  count: getCount,
  subtotal: getSubtotal,
  onUpdate: onUpdate,
  showPopup: showAtcPopup
};
})();